import {Component} from 'react';
import $ from 'jquery';

import './App.css';

import CONFIG from '../global/libs/CONFIG.js';
import myAjax from '../global/libs/myAjax.js';
import {getTokenAjax} from '../global/libs/myAjax.js';
import {DEPT_DATA} from '../global/libs/departmentUtil.js';
import {get_cookie, save_cookie} from '../global/libs/cookie.js';

import QuestionPanel from './QuestionPanel.js';
import AnswerPanel from './AnswerPanel.js';
import QACandidatePanel from './QACandidatePanel.js';
import AppNavbar from './AppNavbar.js';
import AppJumbotron from './AppJumbotron.js';
import AppAlert from './AppAlert.js';
import {USER_INFO} from '../global/libs/authUtil.js';

/**
 *
 * Component structure:
 *

    App
    |-- AppAlert
    |-- AppNavbar
    |-- AppJumbotron
    |   |-- SpeechBtn
    |   |-- QuestionBtn
    |-- QuestionPanel
    |   |-- QuestionPanelHeader
    |   |-- QuestionPanelBody
    |-- AnswerPanel
    |   |-- AnswerPanelTable
    |   |   |-- AnswerPanelTableIsCorrectTr
    |   |   |   |-- TrainModal
    |   |   |-- AnswerPanelTableQuestionsTr
    |-- QACandidatePanel
        |-- QACandidatePanelBottom
            |-- QACandidatePanelBottomMailModal (only used in KEIKO)


    AppMailModal
    |-- QACandidatePanelBottomMailModal
 */

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: <span></span>, // the page object to be rendered
      jumbotronInput: '', // the current display/user_input in the jumbotron input field
      jumbotronImageDisplay: true, // control if display image in jumbotron or not

      askedQuestion: '', // the question that is asked (sent ajax to backend)
      results: [], // the list of results corresponding to the question
      result: {}, // current showing result
      alerts: [],
      log_id: null,
      cgId: '',
      qListClicked: false
    };

    this.updateJumbotronInput = this.updateJumbotronInput.bind(this);
    this.askQuestion = this.askQuestion.bind(this);
    this.generateAlert = this.generateAlert.bind(this);

    // Page transition related
    this.transition = this.transition.bind(this);
    this.backtoQuestionPanel = this.backtoQuestionPanel.bind(this);
    this.gotoQuestionPanel = this.gotoQuestionPanel.bind(this);
    this.backtoAnswerPanel = this.backtoAnswerPanel.bind(this);
    this.gotoAnswerPanel = this.gotoAnswerPanel.bind(this);
    this.backtoQACandidatePanel = this.backtoQACandidatePanel.bind(this);
    this.gotoQACandidatePanel = this.gotoQACandidatePanel.bind(this);
  }

  componentDidMount() {
    // for browser back event
    window.addEventListener(
      'popstate',
      function (e) {
        console.log(e.state);
        switch (e.state) {
          case 'QuestionPanel':
            this.backtoQuestionPanel();
            break;
          case 'AnswerPanel':
            this.backtoAnswerPanel(this.state.result);
            break;
          case 'QACandidatePanel':
            this.backtoQACandidatePanel();
            break;
          default:
            break;
        }
      }.bind(this)
    );

    if (!CONFIG.DISABLE_JWT) {
      getTokenAjax('/get_token/'); // トークン取得API
    }
    this.gotoQuestionPanel();
  }

  updateJumbotronInput(value, callback, qListClicked) {
    // Update question used by input field in jumbotron
    // callback is called after state has been changed: used for direct click in question panel
    this.setState({qListClicked: qListClicked});
    this.setState({jumbotronInput: value}, callback);
  }

  askQuestion() {
    // Update question by jumbotronInput; send question to backend to update results
    const {jumbotronInput} = this.state;

    if (!jumbotronInput) {
      alert('質問を入力してください。');
      return null;
    }
    this.setState({askedQuestion: jumbotronInput});
    console.log('ask question : ', jumbotronInput);

    var json_string = {question: jumbotronInput};

    if (CONFIG.ENABLE_QA_PARAPHRASE === true) {
      json_string = {question: jumbotronInput, paraphrase_limit: -1};
    }
    if (CONFIG.ENABLE_MULTI_DEPT && DEPT_DATA.length > 0) {
      json_string.category_group = DEPT_DATA[0].dept;
      this.setState({cgId: DEPT_DATA[0].dept});
    }

    myAjax('/api/models/predict/', json_string).done(
      function (data) {
        const predicted_list = data.predicted_results;
        const results = predicted_list;
        const log_id = data.log_id;
        save_cookie();

        let web_client_id = get_cookie()['WEB_CLIENT_ID'];
        let user_id = '';

        if (!USER_INFO || !USER_INFO['uid']) {
          user_id = web_client_id;
        } else {
          user_id = USER_INFO['uid'];
        }

        myAjax(
          '/api/logging/core/' + log_id,
          {
            user_client: 'Web Find',
            user_id: user_id
          },
          'PATCH'
        );

        if (predicted_list.length === 0 || predicted_list[0].score === 0) {
          alert('すみません、質問の意味が分かりませんでした。');
        } else {
          this.setState({results: predicted_list});
          this.setState({log_id: log_id});

          console.log(`clicked: ${this.state.qListClicked}`);
          console.log(this.state);

          if (this.state.qListClicked) {
            // 質問一覧クリック時は、完全一致の質問がある場合にスコアに関係なく一致した質問のQAだけを表示する
            let suffix = CONFIG.Q_PERFECT_MATCHING(results, jumbotronInput);
            if (suffix >= 0) {
              // 質問が完全一致する場合は、1つのQAを表示する
              this.gotoAnswerPanel(results[suffix]);
            } else {
              // 同じ質問が複数ある場合は、スコアを考慮して1つのQAもしくはQA一覧を表示する
              if (CONFIG.SCORE_THRESHOLD_RULE(results)) {
                this.gotoAnswerPanel(results[0]);
              } else {
                this.gotoQACandidatePanel();
              }
            }
          } else {
            // 検索窓から質問した場合は、スコアを考慮して1つのQAもしくはQA一覧を表示する
            if (CONFIG.SCORE_THRESHOLD_RULE(results)) {
              this.gotoAnswerPanel(results[0]);
            } else {
              this.gotoQACandidatePanel(results);
            }
          }
          this.setState({qListClicked: false});
        }
      }.bind(this)
    );
  }

  generateAlert(text) {
    if (this.appAlertElm) {
      this.appAlertElm.generate(text);
    }
  }

  transition(pageObject) {
    this.setState({page: pageObject}, () => {
      if (this.dynamicPanel) {
        $(this.dynamicPanel).css('opacity', '0');
        $(this.dynamicPanel).fadeTo(200, 1);
      }
    });
  }

  // transition related
  backtoQuestionPanel() {
    // can goto AnswerPanel
    let nextPage = (
      <QuestionPanel
        gotoAnswerPanel={this.gotoAnswerPanel}
        updateJumbotronInput={this.updateJumbotronInput}
        askQuestion={this.askQuestion}
      />
    );
    this.setState({jumbotronImageDisplay: true});
    this.transition(nextPage);
  }

  gotoQuestionPanel() {
    this.backtoQuestionPanel();
    window.history.pushState('QuestionPanel', null);
  }
  reloadPage() {
    window.location.href = CONFIG.APP_ROUTE;
  }

  backtoAnswerPanel(result) {
    this.setState({jumbotronImageDisplay: false, result: result}, () => {
      this.transition(
        <AnswerPanel
          result={result}
          logId={this.state.log_id}
          cgId={this.state.cgId}
          enableUserRating={this.state.enableUserRating}
          ratingAnswerRequired={this.state.ratingAnswerRequired}
          enableRatingReason={this.state.enableRatingReason}
          ratingReasonMsg={this.state.ratingReasonMsg}
          ratingReasons={this.state.ratingReasons}
          question={this.state.askedQuestion}
          gotoQACandidatePanel={this.gotoQACandidatePanel}
          askQuestion={this.askQuestion}
          generateAlert={this.generateAlert}
        />
      );
    });
  }

  gotoAnswerPanel(result) {
    const pnameEnableUserRating = 'enable_user_rating';
    const pnameRatingAnswerRequired = 'user_rating_required';
    const pnameEnableRatingReason = 'enable_negative_user_rating_reason';
    const pnameRatingReasonMsg = 'msg_ask_why_negative_rating';
    const pnameRatingReasonsPrefix = 'negative_user_rating_reason_answer_';

    myAjax('/api/operation/setting_list/', '', 'GET').done(
      function (data) {
        function getSiteCustomizeData(dictData) {
          if (typeof dictData === 'undefined') {
            return '';
          }
          return dictData.value;
        }
        let enableUserRating = getSiteCustomizeData(data.find((item) => item.name === pnameEnableUserRating));
        let enableRatingReason = getSiteCustomizeData(data.find((item) => item.name === pnameEnableRatingReason));
        let ratingAnswerRequired = getSiteCustomizeData(data.find((item) => item.name === pnameRatingAnswerRequired));
        let ratingReasonMsg = getSiteCustomizeData(data.find((item) => item.name === pnameRatingReasonMsg));

        let ratingReasons = data.filter((item) => item.name.indexOf(pnameRatingReasonsPrefix) === 0);

        this.setState({
          enableUserRating: enableUserRating,
          ratingAnswerRequired: ratingAnswerRequired,
          enableRatingReason: enableRatingReason,
          ratingReasonMsg: ratingReasonMsg,
          ratingReasons: ratingReasons
        });
        this.backtoAnswerPanel(result);
        window.history.pushState('AnswerPanel', null);
      }.bind(this)
    );
  }

  backtoQACandidatePanel() {
    this.setState({jumbotronImageDisplay: false}, () => {
      this.transition(
        <QACandidatePanel
          question={this.state.askedQuestion}
          results={this.state.results}
          logId={this.state.log_id}
          cgId={this.state.cgId}
          gotoAnswerPanel={this.gotoAnswerPanel}
        />
      );
    });
  }
  gotoQACandidatePanel() {
    this.backtoQACandidatePanel();
    window.history.pushState('QACandidatePanel', null);
  }

  render() {
    let {jumbotronImageDisplay} = this.state;
    return (
      <div className="container">
        <AppAlert ref={(node) => (this.appAlertElm = node)} />
        <AppNavbar gotoQuestionPanel={this.reloadPage} />
        <AppJumbotron
          ref={(node) => (this.jumbotron = node)}
          jumbotronInput={this.state.jumbotronInput}
          updateJumbotronInput={this.updateJumbotronInput}
          askQuestion={this.askQuestion}
          imageDisplay={jumbotronImageDisplay}
        />

        <div ref={(node) => (this.dynamicPanel = node)} style={{opacity: 0}}>
          {this.state.page}
        </div>
      </div>
    );
  }
}

export default App;
